<template>
  <el-dialog
    class="dialogForm"
    :title="title"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    width="1070px"
    top="7vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="line"></div>
    <el-form :model="param" label-position="left" size="small" class="demo-ruleForm">
      <el-form-item label="基本信息" class="elFormfont" label-width="1000px"></el-form-item>

      <el-form-item class="formItem" label="产生单位名称" prop="unitName" label-width="150px">
        <el-input
          style="width:300px"
          name="unitName"
          disabled
          v-model="param.unitName"
          placeholder="请输入产生单位名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="统一社会信用代码" class="formItem" prop="creditCode" label-width="150px">
        <el-input style="width:300px" disabled v-model="param.creditCode" placeholder="请输入统一社会信用代码"></el-input>
      </el-form-item>
      <el-form-item label="负责人姓名" class="formItem" prop="headerName" label-width="150px">
        <el-input
          style="width:300px"
          name="headerName"
          disabled
          v-on:input="param.headerName=param.headerName.replace(/[^\u4E00-\u9FA5]/g, '')"
          v-model="param.headerName"
          placeholder="请输入负责人姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="身份证号" class="formItem" prop="idCard" label-width="150px">
        <el-input
          style="width:300px"
          placeholder="请输入身份号"
          name="idCard"
          disabled
          v-model="param.idCard"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系方式" class="formItem" prop="tel" label-width="150px">
        <el-input style="width:300px" placeholder="请输入手机号" name="tel" disabled v-model="param.tel"></el-input>
      </el-form-item>
      <el-form-item label="产生单位类型" class="formItem" prop="unitType" label-width="150px">
        <el-select
          v-model="param.unitType"
          disabled
          style="width:300px"
          clearable
          placeholder="类型选择"
        >
          <el-option
            v-for="item in $storage.getSelectDict('productUnitType')"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区域" class="formItem" prop="area" label-width="150px">
        <el-cascader
          clearable
          style="width:300px"
          :options="options"
          v-model="selectedOptions"
          disabled
          placeholder="请选择区域"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="地址" class="formItem" prop="address" label-width="150px">
        <el-input style="width:300px" disabled v-model="param.address"></el-input>
      </el-form-item>
      <el-form-item label="经度" prop="longitude" label-width="150px" class="formItem">
        <el-input
          size="small"
          style="width:300px"
          v-model="param.longitude"
          name="longitude"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="纬度" prop="latitude" class="formItem" label-width="150px">
        <el-input
          class="formInput"
          size="small"
          style="width:300px"
          v-model="param.latitude"
          name="latitude"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="营业执照" class="formItem" prop="businessLicense" label-width="150px">
        <el-image style="width: 300px; height: 100px " :preview-src-list="srcList1" :src="imgUrl1"></el-image>
        <br />
      </el-form-item>
      <el-form-item label="食品经营许可证" class="formItem" prop="foodBusinessLicense" label-width="150px">
        <el-image style="width: 300px; height: 100px;" :preview-src-list="srcList2" :src="imgUrl2"></el-image>
        <br />
      </el-form-item>

      <el-form-item label="签约信息" class="elFormfont" label-width="1000px"></el-form-item>

      <el-form-item label="座位数/居民户数" class="formItem" prop="householdsNumber" label-width="150px">
        <el-input
          style="width:300px"
          disabled
          name="householdsNumber"
          v-on:input="param.householdsNumber=param.householdsNumber.replace(/[^\d]/g,'')"
          v-model="param.householdsNumber"
          placeholder="请输入座位数/居民户数"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="预估垃圾量(Kg)"
        class="formItem"
        prop="estimatedWasteGeneration"
        label-width="150px"
      >
        <el-input
          style="width:300px"
          disabled
          name="estimatedWasteGeneration"
          placeholder="请输入预估垃圾产生量"
          v-on:input="param.estimatedWasteGeneration=param.estimatedWasteGeneration.replace(/[^\d]/g,'')"
          v-model="param.estimatedWasteGeneration"
        ></el-input>
      </el-form-item>
      <el-form-item label="容器数量(个)" class="formItem" prop="containerAmount" label-width="150px">
        <el-input
          style="width:300px"
          disabled
          name="containerAmount"
          v-on:input="param.containerAmount=param.containerAmount.replace(/[^\d]/g,'')"
          placeholder="请输入容器数量"
          v-model="param.containerAmount"
        ></el-input>
      </el-form-item>
      <el-form-item label="容器容量(L)" class="formItem" prop="binCapacity" label-width="150px">
        <el-select
          disabled
          v-model="param.binCapacity"
          clearable
          style="width:300px"
          placeholder="请选择容器容量"
        >
          <el-option
            v-for="item in containerCapacity"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="收运时间" class="formItem" prop="ctTime" label-width="150px">
        <el-select
          v-model="param.ctTime"
          disabled
          style="width:300px"
          clearable
          placeholder="请选择收运时间"
        >
          <el-option
            v-for="item in $storage.getSelectDict('ctTime')"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="押金金额(元)" class="formItem" prop="depositAmount" label-width="150px">
        <el-input
          style="width:300px"
          name="depositAmount"
          disabled
          v-on:input="param.depositAmount=param.depositAmount.replace(/[^\d]/g,'')"
          placeholder="请输入押金金额"
          v-model="param.depositAmount"
        ></el-input>
      </el-form-item>
      <el-form-item class="formItem" label="押金支付" prop="isDepositPay" label-width="150px">
        <el-radio-group v-model="param.isDepositPay" style="width:300px" disabled>
          <el-radio :label="0" :value="0">未支付</el-radio>
          <el-radio :label="1" :value="1">已支付</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item class="formItem" label="签约状态" prop="spuStatus" label-width="150px">
        <el-select
          v-model="param.spuStatus"
          disabled
          style="width:300px"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in signStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="签约时间" class="formItem" prop="signingDate" label-width="150px">
        <el-date-picker
          v-model="param.signingDate"
          value-format="yyyy-MM-dd"
          style="width:300px"
          type="date"
          disabled
          name="signingDate"
          placeholder="选择签约时间"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="到期时间" class="formItem" prop="expireDate" label-width="150px">
        <el-date-picker
          v-model="param.expireDate"
          value-format="yyyy-MM-dd"
          style="width:300px"
          type="date"
          disabled
          name="expireDate"
          placeholder="选择到期时间"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="登录手机号" class="formItem" prop="logonTel" label-width="150px">
        <el-input
          style="width:300px"
          placeholder="请输入小程序登录手机号"
          name="logonTel"
          disabled
          v-model="param.logonTel"
        ></el-input>
      </el-form-item>
      <el-form-item label="协议" class="formItem" prop="agreement" label-width="150px">
        <el-image style="width: 300px; height: 100px " :preview-src-list="srcList3" :src="imgUrl3"></el-image>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { regionData, CodeToText, TextToCode } from "element-china-area-data";
export default {
  name: "notificationDetail",
  data() {
    return {
      // 城市级联选择
      title: "",
      options: regionData,
      selectedOptions: [],
      dialogVisible: true,
      signStatus: [],
      containerCapacity: [],
      //   弹出表格数据存储
      param: {
        // unitNo: "", //编号
        // spuStatus: "", // 产生单位状态
        unitName: "", //产生单位名称
        creditCode: "", //统一社会信用代码
        headerName: "", //负责人姓名
        idCard: "", //身份证号
        tel: "", //联系方式
        unitType: "", //产生单位类型初始值
        province: "", //省
        city: "", //市
        area: "", //区域
        address: "", // 地址
        businessLicense: "", // 营业执照
        foodBusinessLicense: "", // 食品经营许可证
        agreement: "", //协议
        householdsNumber: "", // 座位数/居民户数
        estimatedWasteGeneration: "", // 预估垃圾产生量
        binCapacity: "", //容器容量
        containerAmount: "", // 容器数量
        depositAmount: "", // 押金金额
        isDepositPay: "", // 押金支付
        // smStatus: "", // 签约状态初始值
        spuStatus: "", // 签约状态
        signingDate: "", // 签约时间
        expireDate: "", //到期时间
        refuseReason: "", //拒绝原因
        breakReason: "", //解约原因
        ctTime: "", //收运时间初始值
        refuseReason: "", //拒绝原因
        breakReason: "", //解约原因
        latitude: "", // 纬度
        longitude: "", //经度
        logonTel: "", //登录手机号
      },
      // 图片预览
      imgUrl1: "",
      imgUrl2: "",
      imgUrl3: "",
      // 大图数组
      srcList1: [],
      srcList2: [],
      srcList3: [],
    };
  },
  methods: {
    handleClose(done) {
      this.$parent.singDataShowShow = false;
      done();
    },
    setData(param) {
      // this.getUserList();
      // 签约状态
      this.signStatus = this.$storage.getSelectDict("signStatus");
      // 容器容量
      this.containerCapacity = this.$storage.getSelectDict("containerCapacity");
      this.param = Object.assign({}, param);
      this.imgUrl1 = api.imageLoadUrl + param.businessLicense;
      this.imgUrl2 = api.imageLoadUrl + param.foodBusinessLicense;
      this.imgUrl3 = api.imageLoadUrl + param.agreement;
      this.srcList1.push(this.imgUrl1);
      this.srcList2.push(this.imgUrl2);
      this.srcList3.push(this.imgUrl3);
      if (param.isDepositPay == null) {
        param.isDepositPay = 0;
      }
      try {
        this.selectedOptions = [
          TextToCode[param.province].code,
          TextToCode[param.province][param.city].code,
          TextToCode[param.province][param.city][param.area].code,
        ];
      } catch (error) {
        this.selectedOptions = [];
      }
      this.title = param.unitName;
      this.param.spuStatus = String(this.param.spuStatus);
      this.param.binCapacity = String(this.param.binCapacity);
    },
    getUserList() {
      //获取人员list
      var that = this;
      that.$util._formPost(
        false,
        that,
        that.ref,
        "",
        api.user_info_list,
        function (_r) {
          let res = _r.data;
          res.forEach((e) => {
            that.userList.push({
              value: e.id,
              label: e.userName,
            });
          });
        }
      );
    },
  },
};
</script>

<style scoped lang='scss'>
.line {
  @include line;
}
.formInput {
  @include formInput(180px);
}
// 提交表单样式
.demo-ruleForm {
  max-height: 400px;
  overflow-y: auto;
  // 单个表单
  div {
    float: left;
  }
  .formItem {
    margin-left: 30px;
  }
  
  // 信息
  .elFormfont {
    font-weight: bold;
  }
  // 照片提交部分
  .upload-demo {
    position: relative;
    width: 200px;
    margin-bottom: 25px;
    .el-upload__tip {
      display: block;
      position: absolute;
      font-size: 12px;
      left: 0;
      bottom: -25px;
    }
  }
}
</style>
<style lang='scss'>
.dialogForm {
  @include dialogForm;
}
</style>


// WEBPACK FOOTER //
// src/components/notification/singDataShow.vue